import React from "react";
import AdminProfile from "./profiles/AdminProfile";
import ContractorProfile from "./profiles/ContractorProfile";
import SupervisorProfile from "./profiles/SupervisorProfile";
import AssignorProfile from "./profiles/AssignorProfile";

const MyProfile: React.FC = () => {
  const userType = localStorage.getItem("userType");

  switch (userType) {
    case "ADMIN":
      return <AdminProfile />;
    case "CONTRACTOR":
      return <ContractorProfile />;
    case "SUPERVISOR":
      return <SupervisorProfile />;
    case "ASSIGNOR":
      return <AssignorProfile />;
  }

  return null;
};

export default MyProfile;
